import Vue from "vue";

Vue.filter("capitalize", function (value) {
  if (typeof value !== "string") {
    return value;
  }
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
});
